<template>
  <layout>
    <div slot="content">
      <i-card title="提现申请">
        <div slot="content">
          <el-form :inline="true" size="small" style="text-align: right">
            <el-form-item>
              <el-input v-model="filter.nickname" placeholder="昵称" clearable></el-input>
            </el-form-item>
            <el-form-item>
              <el-select placeholder="提现状态" style="width: 175px" clearable v-model="filter.cash_status">
                <el-option label="申请中" :value="-1">申请中</el-option>
                <el-option label="已提现" :value="1">已提现</el-option>
                <el-option label="提现失败" :value="2">提现失败</el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="getApplyList">查找</el-button>
              <el-button type="primary" @click="reset">重置</el-button>
            </el-form-item>
          </el-form>
          <el-table :data="applyList" :border="true" v-loading="loading">
            <el-table-column prop="cash_id" width="180px" label="提现编号"></el-table-column>
            <el-table-column prop="nickname" width="120px" label="申请人"></el-table-column>
            <el-table-column prop="mobile" width="140px" label="联系人手机"></el-table-column>
            <el-table-column prop="total" label="申请金额"></el-table-column>
            <el-table-column prop="wechat_no" width="280px" label="微信流水"></el-table-column>
            <el-table-column prop="cash_status_name" label="申请状态">
              <template slot-scope="scope">
                <el-tag size="mini" v-if="scope.row.cash_status === -1">{{ scope.row.cash_status_name }}</el-tag>
                <el-tag size="mini" v-if="scope.row.cash_status === 1" type="success">{{ scope.row.cash_status_name }}
                </el-tag>
                <el-tag size="mini" v-if="scope.row.cash_status === 2" type="danger">{{ scope.row.cash_status_name }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="verify_at" width="160px" label="审核时间"></el-table-column>
            <el-table-column prop="created_at" width="160px" label="申请时间"></el-table-column>
            <el-table-column label="操作" fixed="right" width="150">
              <div slot-scope="scope">
                <el-button size="mini" type="success" @click="verifyCash(scope.row.cash_id,1)">通过</el-button>
                <el-button size="mini" type="danger" @click="verifyCash(scope.row.cash_id,2)">拒绝</el-button>
              </div>
            </el-table-column>
          </el-table>
        </div>
        <div slot="right-menu">
        </div>
        <div class="page-wrap">
          <el-pagination
            background
            :current-page="pageInfo.current_page"
            layout="prev, pager, next"
            page-size="15"
            @current-change="changePage"
            :total="pageInfo.total">
          </el-pagination>
        </div>
      </i-card>
    </div>
  </layout>
</template>

<script>
export default {
  name: "cate",
  data() {
    return {
      applyList: [],
      loading: false,
      postLoading: false,
      pageInfo: {
        current_page: 1,
        total: 0
      },
      showGroup: false,
      currUser: {},
      groupList: [],
      filter: {
        nickname: "",
        cash_status: "",
      }
    }
  },
  methods: {
    getApplyList: function () {
      this.loading = true;
      this.$http.request('cashList', {filter: this.filter}).then(res => {
        this.applyList = res.data;
        this.loading = false;
        this.pageInfo = res.meta;
      });
    },
    changePage: function (page) {
      this.pageInfo.current_page = page;
      this.getApplyList();
    },
    verifyCash: function (cashId, cashStatus) {
      let tips = cashStatus === 1 ? '确定通过提现吗?' : '确定拒绝提现吗?';
      this.$confirm(tips, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.request('verifyCash', {cash_id: cashId, cash_status: cashStatus}).then((res) => {
          let _self = this;
          if (res.status === 'success') {
            this.$message({
              type: 'success',
              message: res.message,
              onClose: function () {
                _self.getApplyList();
              }
            });
          }
        });
      })
    },
    reset: function () {
      window.location.reload();
    }
  },
  created: function () {
    this.getApplyList();
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/order/cash-list.vue